import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useExamObservations } from 'src/features/visits/telemed/hooks/useExamObservations';
import { StatelessExamCheckbox } from './StatelessExamCheckbox';

type ControlledExamCheckboxProps = {
  label: string;
  name: string;
  abnormal?: boolean;
};

export const ControlledExamCheckbox: FC<ControlledExamCheckboxProps> = (props) => {
  const { label, name, abnormal } = props;
  const { t } = useTranslation();

  const { value: field, update, isLoading } = useExamObservations(name);

  const onChange = (value: boolean): void => {
    update({ ...field, value });
  };

  const i18nKey = label.startsWith('telemed.') ? label : `telemed.exam.labels.${label}`;

  return (
    <StatelessExamCheckbox
      label={t(i18nKey, label)}
      abnormal={abnormal}
      checked={field.value}
      onChange={onChange}
      disabled={isLoading}
    />
  );
};
